var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFluent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1261157222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1261157220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M80 0V12.87C80 27.6867 68.1 39.7233 53.33 39.9617L52.8817 39.9667H40V52.87C40 68.1117 27.9 80 12.9917 80H0V66.7467V37.9333C0 16.9833 17 0 37.9667 0H80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8267 0H80V12.87C80 28.1117 67.9 40 52.9917 40H40V26.7583C40 13.2533 49.8883 2.05667 62.8267 0Z",
    fill: "#242265",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M80 0V12.87C80 27.6867 68.1 39.7233 53.33 39.9617L52.8817 39.9667H40V52.87C40 68.1117 27.9 80 12.9917 80H0V66.7467V37.9333C0 16.9833 17 0 37.9667 0H80Z",
    fill: "#616EE1",
    fillOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluent);
export default __webpack_public_path__ + "static/media/fluent.51e7344094f8b3a08523de7cbc86c33b.svg";
export { ForwardRef as ReactComponent };